import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Alert, Radio, Spin} from "antd"
import {listSku} from "../../../../../services/api/3dApi"

class FilterTypes extends Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: false,
            error: '',
            options: []
        }
    }

    componentDidMount = async () => {
        await this._fetchOrderType()

        const {onChangeTypeID, defaultValue} = this.props
        const {options} = this.state
        const type = !!options ? options.find(item => item.sku === defaultValue) : {}

        if (typeof onChangeTypeID === 'function') {
            onChangeTypeID(type !== undefined ? type._id : '')
        }
    }

    _fetchOrderType = async () => {
        this.setState({
            loading: true,
            error: ''
        })
        try {
            const {data: response} = await listSku()

            const {data, success, error} = response

            if (!success) {
                return this.setState({
                    loading: false,
                    error: error
                })
            }

            const regex = /\s/

            const newData = data.length > 0 && data.filter((item) => {
                return !regex.test(item.sku) && item
            })

            this.setState({
                loading: false,
                options: newData
            })

        } catch (e) {
            this.setState({
                loading: false,
                error: e.message
            })
        }
    }

    _handleChangeType = (e) => {
        const {value} = e.target
        const {onChange, onChangeTypeID} = this.props
        const {options} = this.state
        const type = options.find(item => item.sku === value)

        if (typeof onChange === 'function' && typeof onChangeTypeID === 'function') {
            onChange('type', value)
            onChangeTypeID(type !== undefined ? type._id : '')
        }
    }

    render() {
        const {defaultValue} = this.props
        const {options, loading, error} = this.state

        return (
            error ? <Alert message={error} type={'error'}/> :
                <div className='FilterTypes'>
                    <div className='mb-1 font-weight-bold'>Loại sản phẩm:</div>
                    <div className='btn-group btn-group-toggle'>
                        <Spin spinning={loading}>
                            <Radio.Group value={defaultValue} onChange={this._handleChangeType}>
                                <Radio.Button value={''}>Tất cả</Radio.Button>
                                {
                                options.length > 0 && options.map((type) => {
                                    const {created_at} = type
                                    const currentDate = new Date()
                                    const differenceInDays = (currentDate - new Date(created_at)) / (1000 * 60 * 60 * 24)
                                    const style = {
                                        color : '#e91616',
                                        fontWeight : 600,
                                    }
                                    return <Radio.Button style={differenceInDays < 60 ? style : {}} key={type._id} value={type.sku}>{type.sku}</Radio.Button>
                                })
                            }
                            </Radio.Group>
                        </Spin>
                    </div>
                </div>
        )
    }
}

FilterTypes.propTypes = {
    defaultValue: PropTypes.string,
    onChange: PropTypes.func.isRequired
}

export default FilterTypes
